import HomeComponent from "../../components/home/home.component";

const HomePage = () => {
  return <HomeComponent />
}

export default HomePage;